import React, { memo } from 'react';
import PropTypes from 'prop-types';
import { capitalize } from '@mui/material/utils';
import { makeStyles } from 'tss-react/mui';

const useStyles = makeStyles()((theme) => ({
  root: {
    width: '1em',
    height: '1em',
    userSelect: 'none',
    overflow: 'hidden',
    textAlign: 'center',
    flexShrink: 0,
  },
  colorInherit: {
    color: 'inherit',
  },
  colorPrimary: {
    color: theme.palette.primary.main,
  },
  colorSecondary: {
    color: theme.palette.secondary.main,
  },
  colorAction: {
    color: theme.palette.action.active,
  },
  colorError: {
    color: theme.palette.error.main,
  },
  colorDisabled: {
    color: theme.palette.action.disabled,
  },
  fontSizeInherit: {
    fontSize: 'inherit',
  },
  fontSizeDefault: {
    fontSize: theme.typography.pxToRem(24),
  },
  fontSizeSmall: {
    fontSize: theme.typography.pxToRem(16),
  },
  fontSizeLarge: {
    fontSize: theme.typography.pxToRem(36),
  },
}));

function JlifeIcon({ children, className, component: Component = 'span', fontSize = 'default', color = 'inherit' }) {
  const { classes, cx } = useStyles();
  return (
    <Component
      className={cx(
        classes.root,
        classes[`fontSize${capitalize(fontSize)}`],
        classes[`color${capitalize(color)}`],
        `jlife-${children}`,
        className,
      )}
    />
  );
}

JlifeIcon.propTypes = {
  children: PropTypes.string.isRequired,
  className: PropTypes.string,
  component: PropTypes.elementType,
  fontSize: PropTypes.oneOf(['inherit', 'default', 'small', 'large']),
  color: PropTypes.oneOf(['inherit', 'primary', 'secondary', 'action', 'error', 'disabled']),
};

export default memo(JlifeIcon);
